import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { WatchStatusTypes } from '@/store/modules/watch-list/types'

enum ModelTypes {
  WatchList = 'watch-list',
}

enum ModelTypeNames {
  WatchList = 'watchList',
}

export type WatchListAttributes = {
  patientId: string
  userId: string
  reason?: string
  watchStatus: 'manual' | 'unwatch' | 'auto'
}

export type WatchListSchema = {
  id: string
  attributes: WatchListAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.WatchList]: {
      keys: {
        remoteId: {},
      },
      attributes: {
        patientId: { type: 'string' },
        userId: { type: 'string' },
        reason: { type: 'string' },
        watchStatus: { type: 'string' },
      },
    },
  },
}

export async function getWatchListQuery(options: { userId: string }) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for watch list')
      return q.findRecords(ModelTypes.WatchList).filter({ attribute: 'uid', value: options.userId })
    })
    .catch(e => {
      console.log('fetch failed for watch list')
      console.log(e)
    })
}

export interface PostWatchListDto {
  attributes: {
    uid: string
    userId: string
    patientId: string
    watchStatus: WatchStatusTypes.MANUAL | WatchStatusTypes.UNWATCH
  }
}

export async function postWatchListQuery(payload: PostWatchListDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling add record for watch list')
    return q.addRecord({
      id: '',
      type: ModelTypeNames.WatchList,
      attributes: payload.attributes,
    })
  })
}

export interface PatchWatchListDto {
  id: string
  attributes: {
    userId: string
    uid: string
    watchStatus: WatchStatusTypes.MANUAL | WatchStatusTypes.UNWATCH
  }
}

export async function patchWatchListQuery(payload: PatchWatchListDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote.push(q => {
    console.log('Before calling update record for watch list')
    return q.updateRecord({
      ...payload,
      type: ModelTypeNames.WatchList,
    })
  })
}
